// if the validation type  starting  REQ word is there then it is mandetary
// if there is no req word only string is there then it is not mandetary but it should be validated if the value is field

import * as yup from "yup";

const Validation_Obj = {
  PAN: yup
    .string()
    .nullable(true)
    .transform((value) => (value === "" ? null : value))
    .matches(
      /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      "PAN must be exactly 10 characters, with 5 letters followed by 4 numbers and ending with a letter"
    ),
  AADHAAR: yup
    .string()
    .nullable(true)
    .transform((value) => (value === "" ? null : value))
    .matches(/^(\d{4}-\d{4}-\d{4}|\d{12})$/, "Aadhaar number must be 12 digits, or in the format 1234-5678-9012"),
  GST: yup
    .string()
    .nullable(true)
    .transform((value) => (value === "" ? null : value))
    .min(15, "Invalid GSTIN")
    .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, "Invalid GSTIN"),
  EMAIL: yup
    .string()
    .nullable(true)
    .transform((value) => (value === "" ? null : value))
    .email("Invalid email format"),
  IFSC: yup
    .string()
    .nullable(true)
    .transform((value) => (value === "" ? null : value))
    .matches(
      /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/,
      "Invalid IFSC code. Format must be 4 letters followed by 0 and then 6 letters or numbers."
    ),
};

// ex need to write the validationtype in inputschama
// we ned to declere each specific type validations\
// ValidationType:"VALID_STRING",
// ValidationType:"REQ_MOBILE",
// ValidationType:"REQ_GST_PER",
// ValidationType:"MOBILE",
// ValidationType:"EMAIL",
// ValidationType:"GST",
// ValidationType:"PAN",
// ValidationType:"GST_PER",
// ValidationType:"PINCODE",
// ValidationType:"IFSC",
// ValidationType:"BANK_ACC",
// ValidationType:"AADHAAR",

const checkValidationType = (type, field) => {
  let validator;

  // Check if the VALID_STRING type has min/max values and adjust accordingly
  if (type === "VALID_STRING" && (field.min || field.max)) {
    validator = yup.string();

    if (field.min) {
      validator = validator.min(field.min, ` ${field.label} Minimum length should be ${field.min} characters.`);
    }

    if (field.max) {
      validator = validator.max(field.max, ` ${field.label} Maximum length should be ${field.max} characters.`);
    }
  } else if (type === "VALID_NUMBER" && (field.min || field.max)) {
    let MIN = field.min || 1;
    let MAX = field.max || 10000;
    const regexPattern = new RegExp(`^[A-Za-z0-9\-_@#&]{${MIN},${MAX}}$`);
    validator = yup
      .string()
      .nullable(true)
      .transform((value) => (value === "" ? null : value))
      .matches(regexPattern, `${field.label} must be exactly ${field.min} digits `)
      .notRequired();
  } else {
    // For other types, start with the predefined validation fr om Validation_Obj
    // or a default notRequired mixed type if the type isn't found
    // validator = Validation_Obj[type] || yup.mixed().notRequired();
    validator = Validation_Obj[type] || yup.mixed().notRequired();
  }

  // Apply the required validation based on the isRequired property
  if (field.isRequired) {
    validator = validator.required(`${field.label || field.name} is required `);
  }

  return validator;
};

export const Formik_Vschema = (data) => {
  const formSchema = data?.reduce((acc, field) => {
    if (field.name === "Sidebyside") {
      field.Subfields?.forEach((subField) => {
        acc[subField.name] = checkValidationType(subField.ValidationType, subField);
      });
    } else {
      acc[field.name] = checkValidationType(field.ValidationType, field);
    }
    return acc;
  }, {});

  return yup.object().shape(formSchema);
};
